/**
 * @remarks The option unique identifier should match the route name for simplicity.
 */

export const featuresMenuOptions = [
  {
    id: "features.custom-links",
    title: "Link Editor",
    message: "Keep all your links dynamic, and extend their value in the long run",
    iconClass: "fa-pen",
    attributes: { to: { name: "features.custom-links" } },
  },
  {
    id: "features.branded-links",
    title: "Branded Links",
    message: "Turn heads and hold attention with fully custom short links",
    iconClass: "fa-link",
    attributes: { to: { name: "features.branded-links" } },
  },
  {
    id: "features.qr-code-generator",
    title: "QR Code Generator",
    message: "Elevate your customer's experiences with dynamic, scannable codes",
    iconClass: "fa-qrcode",
    attributes: { to: { name: "features.qr-code-generator" } },
  },
  {
    id: "features.link-management",
    title: "Link Management",
    message: "Organize as many links as you need with our powerful, intuitive platform",
    iconClass: "fa-list-check",
    attributes: { to: { name: "features.link-management" } },
  },
  {
    id: "features.link-analytics",
    title: "Short URL Tracking",
    message: "Measure the success of your efforts and make smarter, data-driven choices",
    iconClass: "fa-crosshairs",
    attributes: { to: { name: "features.link-analytics" } },
  },
  {
    id: "features.short-url-api",
    title: "Short URL API",
    message: "Build powerful apps and automations with our link shortening API",
    iconClass: "fa-code",
    attributes: { to: { name: "features.short-url-api" } },
  },
];

export const resourcesMenuOptions = [
  {
    id: "blog",
    title: "Blog",
    message: "Read the latest tips and tricks from the top experts in link shortening",
    iconClass: "fa-file-lines",
    attributes: { to: { name: "blog" } },
  },
  {
    id: "dev",
    title: "For Developers",
    message: "Power your apps and software with automated, fully custom URL shortening",
    iconClass: "fa-file-code",
    attributes: { to: { name: "resources.dev" } },
  },
  {
    id: "resources.our-proven-process",
    title: "Our Proven Process",
    message: "Learn how our customers go from zero to hero with our link management tools",
    iconClass: "fa-circle-check",
    attributes: { to: { name: "resources.our-proven-process" } },
  },
  {
    id: "resources.about-us",
    title: "About Us",
    message: "Learn about TinyURL's journey as the first link shortener",
    iconClass: "fa-id-card",
    attributes: { to: { name: "resources.about-us" } },
  },
];
